import { render } from "./TransactionGroupCard.vue?vue&type=template&id=00f4b0f5&scoped=true"
import script from "./TransactionGroupCard.vue?vue&type=script&lang=js"
export * from "./TransactionGroupCard.vue?vue&type=script&lang=js"

import "./TransactionGroupCard.vue?vue&type=style&index=0&id=00f4b0f5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00f4b0f5"]])

export default __exports__